import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa"; // Using react-icons for calendar icon


interface NewDateRangePickerProps {
  value?: [Date | null, Date | null];
  onChange: (dates: [Date | null, Date | null]) => void;
  placeholder?: string;
  disableFutureDates?: boolean;
}

const NewDateRangePicker: React.FC<NewDateRangePickerProps> = ({
  value = [null, null],
  onChange,
  placeholder = "Select Date Range",
  disableFutureDates = false,
}) => {
  const [startDate, endDate] = value || [null, null];

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    onChange(dates);
  };

  const filterFutureDates = (date: Date) => {
    return disableFutureDates ? date <= new Date() : true;
  };

  return (
    <div className="date-picker-wrapper" style={{ position: "relative", display: "inline-block" }}>
      <DatePicker
        selectsRange
        startDate={startDate}
        endDate={endDate}
        onChange={handleDateChange}
        isClearable
        showMonthDropdown
        showYearDropdown
        dateFormat="dd/MM/yyyy"
        placeholderText={placeholder}
        filterDate={filterFutureDates}
        className="form-control pl-6" // padding-left for icon space
      />
      <FaCalendarAlt
        style={{
          position: "absolute",
          left: 150,
          top: "50%",
          transform: "translateY(-50%)",
          color: "#555",
          pointerEvents: "none", // allows clicking the input
        }}
      />
    </div>
  );
};

export default NewDateRangePicker;
